import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  it: {
    translation: {
      nav: {
        categories: "Categorie",
        bestsellers: "Bestseller",
        shop: "Shop",
        store: "Negozio",
        about: "About",
        club: "Club",
        account: "Account",
        login: "Login",
        logout: "Logout",
      },
      hero: {
        drop: "Drop #07 — Neo Tokyo Collection",
        line1: "Action figure",
        line2: "che mordono",
        line3: "il buio.",
        subtitle: "Daita 'n' Jack è la bottega indipendente di Silvano e Filippo, padre e figlio. Action figure, statue e edizioni limitate spedite da Viareggio — dal 2002, perché la passione non si arrugginisce.",
        cta_shop: "Entra nello Shop",
        cta_bestsellers: "Bestseller",
        stats_happy: "Otaku Felici",
        stats_drops: "Drop Esauriti",
        stats_shipping: "Spedizione",
        quote: '"COLLEZIONA O MUORI."',
        chapter: "— Capitolo 1",
        limited_incoming: "Edizione limitata in arrivo",
        marquee: "★ Spedito da Viareggio ★ Padre & Figlio dal 2002 ★ Edizioni numerate ★ Daita 'n' Jack 大太 ★",
      },
      categories: {
        eyebrow: "CATEGORIE / 01",
        title_1: "Scegli la tua",
        title_2: "arma",
        subtitle: "Quattro sezioni. Una sola filosofia: ogni pezzo è una pagina di manga che ti sei portato a casa.",
        explore: "Esplora →",
        action_figures: "Action Figure",
        toys: "Giocattoli",
        limited: "Edizioni Limitate",
        merch: "Merchandise",
        all: "Tutti",
      },
      bestsellers: {
        eyebrow: "POPOLARI / TOP DROPS",
        title_1: "I più",
        title_accent: "temuti",
        title_2: "della mensola",
        subtitle: "Quattro figure che continuano a sparire dal magazzino. Se le vuoi, fai presto.",
      },
      just_dropped: {
        eyebrow: "新作 / JUST DROPPED",
        title_1: "Appena",
        title_accent: "arrivati",
        subtitle: "Le ultime novità entrate in bottega. Pezzi freschi, scaffali ancora caldi.",
        badge: "Nuovo",
      },
      shop: {
        eyebrow: "PRODOTTI / 02",
        title_1: "Tutta la",
        title_accent: "collezione",
        subtitle: "Dieci pezzi. Ognuno con una storia. Filtra per categoria e trova quello che ti chiama.",
        empty: "Nessun prodotto in questa categoria.",
        search_placeholder: "Cerca per nome, brand, dimensioni, descrizione…",
        search_clear: "Pulisci ricerca",
        search_empty: "Nessun risultato per la tua ricerca.",
        search_results_one: "{{count}} risultato",
        search_results_other: "{{count}} risultati",
      },
      shop_page: {
        eyebrow: "SHOP / カタログ",
        title_1: "Tutto il",
        title_accent: "catalogo",
        subtitle: "Ogni pezzo entrato in bottega. Filtra, cerca, ordina — la tua prossima ossessione è qui dentro.",
        filters: "Filtri",
        close: "Chiudi",
        filter_categories: "Categorie",
        filter_price: "Prezzo (€)",
        filter_price_min: "Prezzo minimo",
        filter_price_max: "Prezzo massimo",
        filter_flags: "Etichette",
        filter_in_stock: "Solo disponibili",
        filter_bestseller: "Solo Bestseller",
        filter_limited: "Solo Edizione limitata",
        filter_brand: "Brand",
        filter_license: "Licenza",
        filter_line: "Product line",
        filter_any: "Tutti",
        sort_label: "Ordina",
        sort_newest: "Più recenti",
        sort_price_asc: "Prezzo crescente",
        sort_price_desc: "Prezzo decrescente",
        sort_name: "Nome A → Z",
        reset: "Reset filtri",
        results_one: "{{count}} prodotto",
        results_other: "{{count}} prodotti",
        empty_title: "Nessun prodotto trovato",
        empty_subtitle: "Prova ad allargare i filtri o resetta la ricerca.",
        show_results_one: "Mostra {{count}} risultato",
        show_results_other: "Mostra {{count}} risultati",
      },
      search: {
        button: "Cerca",
        open: "Apri ricerca",
        close: "Chiudi ricerca",
        title_1: "Cosa stai",
        title_accent: "cercando?",
        hint: "Inizia a digitare per cercare in tutto il catalogo.",
        loading: "Caricamento…",
        recent: "Ricerche recenti",
        recent_remove: "Rimuovi",
        clear_all: "Cancella tutte",
      },
      product: {
        add_to_cart: "Aggiungi al carrello",
        added: "{{name}} aggiunto al carrello",
        bestseller: "Bestseller",
        limited: "Limited",
        only_x_left: "Solo {{n}}",
        view_details: "Vedi dettagli",
        in_stock: "Disponibili: {{n}}",
        out_of_stock: "Esaurito",
        reviews: "Recensioni",
        no_reviews: "Nessuna recensione ancora. Sii il primo.",
        write_review: "Scrivi una recensione",
        edit_review: "Modifica la tua recensione",
        update_review: "Aggiorna",
        login_to_review: "Accedi per scrivere una recensione",
        your_rating: "Il tuo voto",
        your_comment: "Il tuo commento",
        submit_review: "Pubblica",
        review_submitted: "Recensione pubblicata",
        avg_rating: "{{rating}} su 5",
        rating_count_one: "{{count}} recensione",
        rating_count_other: "{{count}} recensioni",
        wishlist_add: "Aggiungi ai preferiti",
        wishlist_remove: "Rimuovi dai preferiti",
        wishlist_added: "Aggiunto ai preferiti",
        wishlist_removed: "Rimosso dai preferiti",
        login_to_wishlist: "Accedi per salvare nei preferiti",
        back_to_shop: "← Torna allo shop",
      },
      about: {
        eyebrow: "MANIFESTO",
        title_1: "Padre. Figlio.",
        title_accent: "Una mensola.",
        title_2: "Nessun",
        title_3: "algoritmo.",
        p1: "Daita 'n' Jack ha aperto nel 2002. Silvano portava in bottega le statuine introvabili — cresciuto tra Gaiking, Goldrake e la voce di Cristina D'Avena. Per anni il negozio ha tenuto in vita una comunità che non voleva morire.",
        p2: "Poi ha chiuso. Tutto è finito in cantina. Ma la passione non si arrugginisce: nel dicembre 2022 suo figlio Filippo l'ha tirata fuori dalla polvere. Stessa idea, stesso fuoco. Ad agosto 2025 il negozio fisico riapre a Viareggio.",
        p3: "Qui non sei un ordine. Sei qualcuno con gusti precisi. Ci sediamo, parliamo, ti aiutiamo a scegliere la prossima storia per la tua mensola.",
        feat1_t: "Padre & Figlio",
        feat1_d: "Curato a mano. Niente magazzino anonimo.",
        feat2_t: "Vintage & Rari",
        feat2_d: "Pezzi che altri hanno smesso di cercare.",
        feat3_t: "Consiglio umano",
        feat3_d: "Ti risponde chi quei cartoni li ha vissuti.",
      },
      store: {
        eyebrow: "STORE / 04 · 店舗",
        title_1: "Vieni a toccarle",
        title_accent: "con mano.",
        subtitle: "Il negozio fisico Daita 'n' Jack è aperto a Viareggio dal 1° agosto 2025. Stile fiera del fumetto: ogni statua in esposizione, illuminata, pronta per essere studiata prima di entrare nella tua mensola.",
        feat1_t: "Esposizione tattile",
        feat1_d: "Niente vetrine sigillate. Avvicinati, gira intorno alla statua, guarda i dettagli che le foto non mostrano.",
        feat2_t: "Consigli faccia a faccia",
        feat2_d: "Cerchi un regalo, una chicca, un'edizione rara? Ci sediamo e troviamo il pezzo giusto per te.",
        feat3_t: "Edizioni che non escono online",
        feat3_d: "Alcune vecchie scuole, alcuni vintage e alcune chicche restano solo in negozio. Vale la pena passare.",
        location_label: "Indirizzo",
        location_value: "Viale Regina Margherita, 88 · 55049 Viareggio (LU) — Italia",
        open_label: "Aperto dal",
        open_value: "1° Agosto 2025",
        phone_label: "Telefono",
        phone_value: "+39 340 731 2505",
        hours_label: "Orari di apertura",
        hours_mon: "Lunedì",
        hours_tue: "Martedì",
        hours_wed: "Mercoledì",
        hours_thu: "Giovedì",
        hours_fri: "Venerdì",
        hours_sat: "Sabato",
        hours_sun: "Domenica",
        hours_lun_gio: "17:00 — 19:00",
        hours_weekend: "10:00 — 13:00 · 17:00 — 19:30 · 20:30 — 23:00",
        hours_range_weekday: "Lun – Gio",
        hours_range_weekend: "Ven – Dom",
        hours_closed: "CHIUSO",
        cta_call: "Chiamaci",
        cta_contact: "Scrivici per orari e indirizzo",
        cta_map: "Indicazioni",
        pickup_note: "Ordina online · Ritira in negozio se vuoi.",
      },
      newsletter: {
        eyebrow: "CARD / DAITA'N'CLUB",
        title_1: "Tu, una card.",
        title_2: "Sei livelli di gloria.",
        subtitle: "Daita'n'Card è il programma fedeltà di Daita'n'Jack. Ogni acquisto, ogni 'invita un amico', ogni passaggio sul sito ti fa salire di livello: da DaitanDeshi (10€ di sconto) a DaitanGod (120€ senza vincoli). Premi seri, nomi seri.",
        tiers_title: "I sei livelli del Club",
        tier_deshi: "DaitanDeshi",
        tier_deshi_desc: "10€ sconto / 80 pt",
        tier_padawan: "DaitanPadawan",
        tier_padawan_desc: "20€ sconto / 150 pt",
        tier_sensei: "DaitanSensei",
        tier_sensei_desc: "40€ sconto / 280 pt",
        tier_hero: "DaitanHero",
        tier_hero_desc: "50€ senza vincoli / 500 pt",
        tier_king: "DaitanKing",
        tier_king_desc: "80€ senza vincoli / 800 pt",
        tier_god: "DaitanGod",
        tier_god_desc: "120€ senza vincoli / 1100 pt",
        form_title: "Richiedi la tua Daita'n'Card",
        form_hint: "Lascia i tuoi dati: ti contattiamo per consegnarti la card (gratuita) e attivare la raccolta punti.",
        first_name: "Nome",
        last_name: "Cognome",
        phone: "Cellulare",
        placeholder_email: "LA TUA EMAIL",
        placeholder_first: "Nome",
        placeholder_last: "Cognome",
        placeholder_phone: "+39 ___ _______",
        submit: "Voglio la card",
        submitting: "Invio...",
        success: "Richiesta ricevuta. Ti contattiamo a breve.",
        already: "Sei già nel club. Ti aggiorniamo presto.",
        disclaimer: "Nessuno spam. Solo offerte e drop riservati.",
      },
      footer: {
        tagline: "La bottega indipendente di Silvano e Filippo. Padre e figlio, statue da collezione, edizioni numerate. Da Viareggio direttamente nella tua mensola — dal 2002.",
        shop: "Shop", brand: "Brand", help: "Help",
        manifesto: "Manifesto", drop_club: "Drop Club", lookbook: "Lookbook", contact: "Contatti",
        shipping: "Spedizioni", returns: "Resi", auth: "Autenticità", faq: "FAQ",
        copyright: "© 2025 Daita 'n' Jack. Tutti i drop riservati.",
        made_in: "Spedito da Viareggio · 大太とジャック",
        admin: "Admin",
      },
      cart: {
        title: "Carrello",
        empty: "Carrello vuoto",
        empty_sub: "Vai a colpire qualcosa",
        remove: "Rimuovi",
        subtotal: "Subtotale",
        checkout: "Vai al checkout",
        free_shipping: "Spedizione gratis sopra € 150",
      },
      checkout: {
        title: "Checkout",
        name: "Nome completo",
        email: "Email",
        address: "Indirizzo",
        city: "Città",
        postal: "CAP",
        country: "Paese",
        total: "Totale",
        submit: "Conferma ordine",
        submitting: "Invio ordine...",
        success: "Ordine confermato",
        success_id: "ID Ordine:",
        success_msg: "Ti abbiamo inviato la conferma a",
        success_eta: "Il drop arriva entro 3-5 giorni.",
        continue: "Continua lo shopping",
        disclaimer: "Pagamento simulato per demo. Nessun addebito reale.",
      },
      auth: {
        login: "Accedi",
        register: "Registrati",
        logout: "Esci",
        no_account: "Non hai un account?",
        have_account: "Hai già un account?",
        name: "Nome",
        email: "Email",
        password: "Password",
        login_title: "Accedi al tuo account",
        register_title: "Crea il tuo account",
        login_btn: "Entra",
        register_btn: "Registrati",
        welcome: "Bentornato",
        welcome_new: "Benvenuto nel club",
        error: "Credenziali errate",
      },
      account: {
        title: "Il mio account",
        eyebrow: "AREA RISERVATA",
        tab_profile: "Profilo",
        tab_orders: "Ordini",
        tab_wishlist: "Preferiti",
        profile: "Profilo",
        save: "Salva",
        saved: "Profilo aggiornato",
        new_password: "Nuova password (lascia vuoto per non cambiare)",
        section_personal: "Dati personali",
        section_address: "Indirizzo di spedizione",
        address_hint: "Salvato qui, sarà pre-compilato in fase di checkout.",
        no_orders: "Non hai ancora effettuato ordini.",
        order_id: "Ordine #",
        order_status: "Stato",
        no_wishlist: "La tua wishlist è vuota.",
        view_order: "Dettaglio",
      },
      status: { pending: "In attesa", shipped: "Spedito", delivered: "Consegnato", cancelled: "Annullato" },
    },
  },
  en: {
    translation: {
      nav: {
        categories: "Categories", bestsellers: "Bestsellers", shop: "Shop", store: "Store", about: "About", club: "Club",
        account: "Account", login: "Login", logout: "Logout",
      },
      hero: {
        drop: "Drop #07 — Neo Tokyo Collection",
        line1: "Action figures",
        line2: "that bite",
        line3: "the dark.",
        subtitle: "Daita 'n' Jack is the independent shop of Silvano and Filippo, father and son. Action figures, statues and limited editions shipped from Viareggio — since 2002, because passion doesn't rust.",
        cta_shop: "Enter the Shop",
        cta_bestsellers: "Bestsellers",
        stats_happy: "Happy Otaku",
        stats_drops: "Sold-out Drops",
        stats_shipping: "Shipping",
        quote: '"COLLECT OR DIE."',
        chapter: "— Chapter 1",
        limited_incoming: "Limited edition incoming",
        marquee: "★ Shipped from Viareggio ★ Father & Son since 2002 ★ Numbered editions ★ Daita 'n' Jack 大太 ★",
      },
      categories: {
        eyebrow: "CATEGORIES / 01",
        title_1: "Choose your",
        title_2: "weapon",
        subtitle: "Four sections. One philosophy: every piece is a manga page you brought home.",
        explore: "Explore →",
        action_figures: "Action Figure",
        toys: "Toys",
        limited: "Limited Editions",
        merch: "Merchandise",
        all: "All",
      },
      bestsellers: {
        eyebrow: "POPULAR / TOP DROPS",
        title_1: "The most",
        title_accent: "feared",
        title_2: "on the shelf",
        subtitle: "Four figures that keep disappearing from the warehouse. If you want them, hurry.",
      },
      just_dropped: {
        eyebrow: "新作 / JUST DROPPED",
        title_1: "Just",
        title_accent: "dropped",
        subtitle: "The latest additions to the shop. Fresh pieces, shelves still warm.",
        badge: "New",
      },
      shop: {
        eyebrow: "PRODUCTS / 02",
        title_1: "The entire",
        title_accent: "collection",
        subtitle: "Ten pieces. Each with a story. Filter by category and find the one calling you.",
        empty: "No products in this category.",
        search_placeholder: "Search by name, brand, size, description…",
        search_clear: "Clear search",
        search_empty: "No results for your search.",
        search_results_one: "{{count}} result",
        search_results_other: "{{count}} results",
      },
      shop_page: {
        eyebrow: "SHOP / カタログ",
        title_1: "The whole",
        title_accent: "catalogue",
        subtitle: "Every piece landed in the shop. Filter, search, sort — your next obsession is in here.",
        filters: "Filters",
        close: "Close",
        filter_categories: "Categories",
        filter_price: "Price (€)",
        filter_price_min: "Min price",
        filter_price_max: "Max price",
        filter_flags: "Tags",
        filter_in_stock: "In stock only",
        filter_bestseller: "Bestsellers only",
        filter_limited: "Limited only",
        filter_brand: "Brand",
        filter_license: "License",
        filter_line: "Product line",
        filter_any: "Any",
        sort_label: "Sort",
        sort_newest: "Newest",
        sort_price_asc: "Price low → high",
        sort_price_desc: "Price high → low",
        sort_name: "Name A → Z",
        reset: "Reset filters",
        results_one: "{{count}} product",
        results_other: "{{count}} products",
        empty_title: "No products found",
        empty_subtitle: "Try loosening the filters or reset the search.",
        show_results_one: "Show {{count}} result",
        show_results_other: "Show {{count}} results",
      },
      search: {
        button: "Search",
        open: "Open search",
        close: "Close search",
        title_1: "What are you",
        title_accent: "looking for?",
        hint: "Start typing to search the whole catalogue.",
        loading: "Loading…",
        recent: "Recent searches",
        recent_remove: "Remove",
        clear_all: "Clear all",
      },
      product: {
        add_to_cart: "Add to cart",
        added: "{{name}} added to cart",
        bestseller: "Bestseller",
        limited: "Limited",
        only_x_left: "Only {{n}}",
        view_details: "View details",
        in_stock: "In stock: {{n}}",
        out_of_stock: "Out of stock",
        reviews: "Reviews",
        no_reviews: "No reviews yet. Be the first.",
        write_review: "Write a review",
        edit_review: "Edit your review",
        update_review: "Update",
        login_to_review: "Log in to write a review",
        your_rating: "Your rating",
        your_comment: "Your comment",
        submit_review: "Publish",
        review_submitted: "Review published",
        avg_rating: "{{rating}} out of 5",
        rating_count_one: "{{count}} review",
        rating_count_other: "{{count}} reviews",
        wishlist_add: "Add to favorites",
        wishlist_remove: "Remove from favorites",
        wishlist_added: "Added to favorites",
        wishlist_removed: "Removed from favorites",
        login_to_wishlist: "Log in to save to favorites",
        back_to_shop: "← Back to shop",
      },
      about: {
        eyebrow: "MANIFESTO",
        title_1: "Father. Son.",
        title_accent: "One shelf.",
        title_2: "No",
        title_3: "algorithm.",
        p1: "Daita 'n' Jack opened in 2002. Silvano hauled in the unfindable figures — raised on Gaiking, Grendizer and Cristina D'Avena's voice. For years the shop kept alive a community that refused to die.",
        p2: "Then it closed. Everything went into the cellar. But passion doesn't rust: in December 2022 his son Filippo dragged it back out of the dust. Same idea, same fire. August 2025 the physical shop reopens in Viareggio.",
        p3: "You're not an order here. You're someone with precise taste. We sit, we talk, we help you pick the next story for your shelf.",
        feat1_t: "Father & Son", feat1_d: "Hand-curated. No anonymous warehouse.",
        feat2_t: "Vintage & Rare", feat2_d: "Pieces others stopped looking for.",
        feat3_t: "Human advice", feat3_d: "Answered by someone who lived those cartoons.",
      },
      store: {
        eyebrow: "STORE / 04 · 店舗",
        title_1: "Come touch them",
        title_accent: "in person.",
        subtitle: "The physical Daita 'n' Jack shop has been open in Viareggio since August 1st, 2025. Comic-fair style: every statue on display, lit, ready to be studied before joining your shelf.",
        feat1_t: "Hands-on display",
        feat1_d: "No sealed glass. Get close, walk around the statue, see details photos can't show.",
        feat2_t: "Face-to-face advice",
        feat2_d: "Looking for a gift, a rarity, a special edition? We sit down and find the right piece for you.",
        feat3_t: "Editions never online",
        feat3_d: "Some old-school, vintage and rare pieces stay in-store only. Worth the trip.",
        location_label: "Address",
        location_value: "Viale Regina Margherita, 88 · 55049 Viareggio (LU) — Italy",
        phone_label: "Phone",
        phone_value: "+39 340 731 2505",
        hours_label: "Opening hours",
        hours_mon: "Monday",
        hours_tue: "Tuesday",
        hours_wed: "Wednesday",
        hours_thu: "Thursday",
        hours_fri: "Friday",
        hours_sat: "Saturday",
        hours_sun: "Sunday",
        hours_lun_gio: "5:00 PM — 7:00 PM",
        hours_weekend: "10:00 AM — 1:00 PM · 5:00 PM — 7:30 PM · 8:30 PM — 11:00 PM",
        hours_range_weekday: "Mon – Thu",
        hours_range_weekend: "Fri – Sun",
        hours_closed: "CLOSED",
        cta_call: "Call us",
        cta_map: "Get directions",
        pickup_note: "Order online · Pick up in-store if you want.",
      },
      newsletter: {
        eyebrow: "CLUB / DROP CLUB",
        title_1: "Join the",
        title_2: "secret club",
        subtitle: "Early access to drops. Discount codes. Numbered editions before the public. No spam. Only important bullets.",
        placeholder: "YOUR EMAIL",
        submit: "JOIN",
        submitting: "SENDING...",
        disclaimer: "No data selling. No empty promises. Just manga.",
      },
      footer: {
        tagline: "The independent shop of Silvano and Filippo. Father and son, collector statues, numbered editions. From Viareggio straight to your shelf — since 2002.",
        shop: "Shop", brand: "Brand", help: "Help",
        manifesto: "Manifesto", drop_club: "Drop Club", lookbook: "Lookbook", contact: "Contact",
        shipping: "Shipping", returns: "Returns", auth: "Authenticity", faq: "FAQ",
        copyright: "© 2025 Daita 'n' Jack. All drops reserved.",
        made_in: "Shipped from Viareggio · 大太とジャック",
        admin: "Admin",
      },
      cart: {
        title: "Cart",
        empty: "Empty cart",
        empty_sub: "Go hit something",
        remove: "Remove",
        subtotal: "Subtotal",
        checkout: "Go to checkout",
        free_shipping: "Free shipping over € 150",
      },
      checkout: {
        title: "Checkout",
        name: "Full name", email: "Email", address: "Address",
        city: "City", postal: "ZIP", country: "Country",
        total: "Total",
        submit: "Place order", submitting: "Sending order...",
        success: "Order confirmed",
        success_id: "Order ID:",
        success_msg: "We sent confirmation to",
        success_eta: "The drop arrives in 3-5 days.",
        continue: "Continue shopping",
        disclaimer: "Payment simulated for demo. No real charge.",
      },
      auth: {
        login: "Log in", register: "Sign up", logout: "Log out",
        no_account: "Don't have an account?",
        have_account: "Already have an account?",
        name: "Name", email: "Email", password: "Password",
        login_title: "Log into your account",
        register_title: "Create your account",
        login_btn: "Enter", register_btn: "Sign up",
        welcome: "Welcome back", welcome_new: "Welcome to the club",
        error: "Invalid credentials",
      },
      account: {
        title: "My account",
        eyebrow: "MEMBER AREA",
        tab_profile: "Profile", tab_orders: "Orders", tab_wishlist: "Favorites",
        profile: "Profile",
        save: "Save", saved: "Profile updated",
        new_password: "New password (leave empty to keep)",
        section_personal: "Personal info",
        section_address: "Shipping address",
        address_hint: "Saved here, pre-filled at checkout.",
        no_orders: "You haven't placed any orders yet.",
        order_id: "Order #",
        order_status: "Status",
        no_wishlist: "Your wishlist is empty.",
        view_order: "Details",
      },
      status: { pending: "Pending", shipped: "Shipped", delivered: "Delivered", cancelled: "Cancelled" },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Default to Italian for first-time visitors, regardless of browser locale.
    // Users can still switch to English via the language toggle; the choice is persisted in localStorage.
    lng: undefined, // let detector decide when localStorage has a saved choice
    fallbackLng: "it",
    supportedLngs: ["it", "en"],
    interpolation: { escapeValue: false },
    detection: {
      // Only read from localStorage; ignore browser navigator so Italian is the default.
      order: ["localStorage"],
      lookupLocalStorage: "dnj_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
